<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Rabatt erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.discounts.store'))">
                <form-fields :form="form" :discount-type-options="discountTypeOptions" :category-tree="categoryTree" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'categoryTree',
            'discountTypeOptions'
        ],
        data() {
            return {
                form: this.$inertia.form({
                    discount_type: null,
                    name: null,
                    description: null,
                    enabled: true,
                    amount: null,
                    min_order_amount: null,
                    max_order_amount: null,
                    min_total_revenue: null,
                    max_total_revenue: null,
                    valid_from: null,
                    valid_until: null,
                    customers: [],
                    exclude_customers: [],
                    products: [],
                    exclude_products: [],
                    categories: [],
                    exclude_categories: [],
                    manufacturers: [],
                    exclude_manufacturers: [],
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>